module.exports = __webpack_public_path__ + "static/media/remove-format.76def48d.svg";